import React from 'react';
import { Link } from 'react-router-dom';

import { Logo } from '../Header/Logo';

import classes from './FooterCta.scss';
import { FooterFeatures } from './FooterFeatures';

export const FooterCta = React.memo(function FooterCta() {
    return (
        <div className={classes.footerCta}>
            <Link
                aria-label="Click the Woodies footer logo and go back to the home page"
                to="/"
                className={classes.footerCtaLogoLink}
            >
                <Logo variant="normal" logoId="inline-svg-logo-footer" />
            </Link>
            <FooterFeatures />
        </div>
    );
});
